import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HTTP_INTERCEPTORS } from "@angular/common/http";
import { Observable, throwError } from "rxjs";
import { catchError } from 'rxjs/operators';
import { ToastrService } from "ngx-toastr";
import { StorageService } from "../services/storage.service";

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
    
    constructor(
        private toastr: ToastrService,
        private storage: StorageService
    ){}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req)
        .pipe(
            catchError((error, caught) => {

                let errorObj = error;

                if (errorObj.error){
                    errorObj = errorObj.error;
                }

                if (!errorObj.status) {
                    errorObj = JSON.parse(errorObj);
                }

                switch(errorObj.status){
                    case 401:
                        this.handle401(errorObj);
                        break;
                    case 403:
                        this.handle403(errorObj);
                        break;
                    default: 
                        this.handleDefaultError(errorObj);                 
                }
                
                return Observable.throw(errorObj);
        }) as any);
    }

    handle401(errorObj: any) {
        this.toastr.error(errorObj.message, errorObj.error);
    }

    handle403(errorObj) {
        this.toastr.error(errorObj.message, errorObj.error);
    }

    handleDefaultError(errorObj) {
        this.toastr.error(errorObj.message, '');
    }
}

export const ErrorInterceptorProvider = {
    provide: HTTP_INTERCEPTORS,
    useClass: ErrorInterceptor,
    multi: true
}